import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';

@Component({
	selector: 'dashboard-comments-dialog',
	imports: [
		DashboardDialogFramePart,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './comments.dialog.html',
})
export class CommentsDialog implements OnInit {
	public dialog: DialogContext<{ comments: { name: string, comment: string }[], label: string }> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<CommentsDialog>);

	comments: { name: string, comment: string }[] = [];
	label: string = 'Comments';
	actions: DialogAction[] = [];
	cancelAction: DialogAction = {
		id: 'close',
		enabled: signal(true),
		cssClass: signal(undefined),
		visible: signal(true),
		text: signal('Close'),
		linkType: 'no-action',
		willCloseDialog: true,
	};


	ngOnInit(): void {
		this.comments = this.dialog.data?.comments || [];
		this.label = this.dialog.data?.label || 'NO Comments';
		this.actions = [this.cancelAction]
	}
}
